import validate from "H:/Project/vana_front/node_modules/nuxt/dist/pages/runtime/validate.js";
import permission_45global from "H:/Project/vana_front/middleware/permission.global.js";
import manifest_45route_45rule from "H:/Project/vana_front/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  permission_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}